export default __webpack_public_path__ + "static/media/paid-interac.32f82791.svg";